import { render, staticRenderFns } from "./TraxAccountRoleCrudTable.vue?vue&type=template&id=7c38f904"
import script from "./TraxAccountRoleCrudTable.vue?vue&type=script&lang=js"
export * from "./TraxAccountRoleCrudTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports